var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "ul",
      { class: _vm.items.length > 3 ? "totales-list" : "totales-simple-list" },
      _vm._l(_vm.items, function (item, index) {
        return _c(
          "li",
          {
            key: index,
            class:
              _vm.items.length > 3
                ? "totales-item"
                : "totales-item totales-simple-item",
          },
          [
            item.value
              ? _c(
                  "div",
                  [
                    _c("card", {
                      attrs: {
                        declaration: {
                          class: _vm.getCardClassByIterationIndex(index),
                          count: item.value,
                          title: item.text,
                          icon: "fa-chalkboard",
                        },
                      },
                    }),
                  ],
                  1
                )
              : [
                  _c("div", { staticClass: "total-con-grafico" }, [
                    _c(
                      "div",
                      {
                        staticClass: "total-con-grafico__title",
                        staticStyle: {
                          padding: "0 5px !important",
                          "line-height": "0",
                        },
                      },
                      [
                        _vm._v(
                          "\n            " + _vm._s(item.text) + "\n          "
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    item.graficoTorta
                      ? _c(
                          "div",
                          { staticStyle: { "margin-top": "-10px" } },
                          [
                            [
                              _c(
                                "div",
                                [
                                  _c("grafico-dona", {
                                    attrs: { items: item.graficoTorta },
                                  }),
                                ],
                                1
                              ),
                            ],
                          ],
                          2
                        )
                      : _vm._e(),
                  ]),
                ],
            _vm._v(" "),
            item.lista
              ? _c(
                  "div",
                  _vm._l(item.lista, function (text, scIndex) {
                    return _c(
                      "div",
                      { key: scIndex, staticClass: "totales-item__lista-item" },
                      [
                        _c("SmallCard", {
                          attrs: {
                            title: text,
                            className: _vm.getCardClassByIterationIndex(index),
                          },
                        }),
                      ],
                      1
                    )
                  }),
                  0
                )
              : _vm._e(),
          ],
          2
        )
      }),
      0
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }